/**
 * 404 page when the route does not exist.
 */
import * as React from 'react';
import { SearchX } from 'lucide-react';
import { UNAUTH_PARTICLE_INDICES } from '@/components/auth/auth-configs';
import { unauthParticleClass } from '@/components/auth/auth-utils';
import { getErrorMessage } from '@/utils/errors-utils';

/** Full-screen 404 when no route matches the URL. */
export const NotFoundPage: React.FC = () => {
  function renderParticle(index: number): React.ReactNode {
    return (
      <div key={`notfound-particle-${index}`} className={unauthParticleClass('notfound', index)} />
    );
  }

  return (
    <div className="unauth-root">
      <div className="unauth-orb notfound-orb-1" />
      <div className="unauth-orb notfound-orb-2" />
      <div className="unauth-orb unauth-orb-3" />

      <div className="unauth-ring notfound-ring-1" />
      <div className="unauth-ring notfound-ring-2" />
      <div className="unauth-ring unauth-ring-3" />

      {UNAUTH_PARTICLE_INDICES.map(renderParticle)}

      <div className="unauth-card notfound-card">
        <div className="unauth-icon-halo notfound-icon-halo" />

        <div className="unauth-icon-wrap">
          <div className="unauth-icon-ring notfound-icon-ring" />
          <div className="unauth-icon-box notfound-icon-box">
            <SearchX className="unauth-icon notfound-icon" strokeWidth={1.4} />
          </div>
        </div>

        <div className="unauth-code notfound-code">404</div>

        <div className="unauth-scan notfound-scan" />

        <h1 className="unauth-title">{getErrorMessage('pageNotFound')}</h1>

        <p className="unauth-desc">{getErrorMessage('pageNotFoundDetail')}</p>

        <div className="unauth-tag notfound-tag">
          <span className="unauth-tag-dot notfound-tag-dot" />
          <span>Erreur&nbsp;404&nbsp;—&nbsp;Not Found</span>
        </div>
      </div>
    </div>
  );
};
